import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "../lib/tracking";

export const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!getConsent()) setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener("open-cookie-preferences", reopen);
    return () => window.removeEventListener("open-cookie-preferences", reopen);
  }, []);

  if (!open) return null;

  const choose = (granted) => {
    setConsent(granted);
    setOpen(false);
  };

  return (
    <div
      data-testid="cookie-consent-banner"
      role="dialog"
      aria-live="polite"
      className="fixed z-[60] left-3 right-3 bottom-[88px] sm:bottom-5 sm:left-5 sm:right-auto sm:max-w-md rounded-2xl border border-[#E1CE9F] bg-[#FDFBF7]/95 backdrop-blur-md shadow-2xl p-4 sm:p-5 animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <div className="flex items-start gap-3">
        <span className="inline-flex w-9 h-9 shrink-0 items-center justify-center rounded-full bg-[#F4EbD8] text-[#8a6d2f]">
          <Cookie className="w-4 h-4" />
        </span>
        <p className="text-xs sm:text-sm text-[#4A362B] leading-relaxed">
          Usamos cookies de medição para entender quais anúncios trazem nossas leitoras. Nenhum dado pessoal é exibido ou vendido. Você pode aceitar ou recusar.{" "}
          <Link to="/privacidade" data-testid="cookie-consent-privacy-link" className="underline text-[#8a6d2f] hover:text-[#3A2921]">Política de Privacidade</Link>
        </p>
      </div>
      <div className="mt-3 flex gap-2 justify-end">
        <button
          type="button"
          data-testid="cookie-consent-reject"
          onClick={() => choose(false)}
          className="rounded-full px-4 py-2 text-xs font-semibold text-[#6E5A4F] border border-[#E5DCCF] hover:bg-[#F4EFE6] transition-colors"
        >
          Recusar
        </button>
        <button
          type="button"
          data-testid="cookie-consent-accept"
          onClick={() => choose(true)}
          className="rounded-full px-5 py-2 text-xs font-bold text-[#2A1D16] bg-[#C5A059] hover:bg-[#B08B44] transition-colors"
        >
          Aceitar
        </button>
      </div>
    </div>
  );
};
